import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "autoscaler-card" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = ["alt"]
const _hoisted_4 = {
  key: 1,
  class: "details"
}
const _hoisted_5 = {
  key: 0,
  class: "label text-deemphasized"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "value"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "text-warning"
}

import { computed, ComputedRef } from 'vue';
import { useFetch } from '@shell/components/Resource/Detail/FetchLoader/composables';
import { useInterval } from '@shell/composables/useInterval';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';

export interface Props {
  value: any;
}

export interface Detail {
  label: string;
  value?: string | { component: any; props: any };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoscalerCard',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const i18n = useI18n(store);

const fetch = useFetch(async() => {
  return await props.value.loadAutoscalerDetails();
});

// The backend only updates the configmap every 10 seconds and we don't cache the configmap in the stores
useInterval(() => fetch.value.refresh(), 10000);

const details: ComputedRef<Detail[]> = computed(() => fetch.value.data);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(fetch).loading && !_unref(fetch).refreshing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "icon icon-lg icon-spinner icon-spin",
            alt: _unref(i18n).t('autoscaler.card.loadingAlt')
          }, null, 8, _hoisted_3)
        ]))
      : (_unref(fetch).data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                key: detail.label,
                class: "detail"
              }, [
                (detail.value)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(detail.label), 1))
                  : (detail.label)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(detail.label), 1))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (detail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (typeof detail.value === 'object')
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(detail.value.component), _mergeProps({
                            key: 0,
                            ref_for: true
                          }, detail.value.props), null, 16))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(detail.value), 1))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(i18n).t('autoscaler.card.loadingError')), 1))
  ]))
}
}

})